import React, { Component } from "react";
import "./Participation.scss";
import BronzeMedal from "../../assets/BronzeMedal.png";
import GoldMedal from "../../assets/GoldMedal.png";
import SilverMedal from "../../assets/SilverMedal.png";
const TDstyle = {
  padding: "3px 6px",
  width: "150px",
};
export default class Participation extends Component {
  render() {
    return (
      <div className="Participation">
        <div className="tools-challenge">
          <h2 id="Participation" style={{ marginTop: " 0px" }}>
            Participation
          </h2>
          <p>
            The CitySCENE Challenge 2020 is a team-based contest. Each team can
            have one or more members and each individual cannot be a member of
            multiple teams.
          </p>
          <div className="medal">
            <div>
              <img src={GoldMedal} alt="" />
              <p>$2,000</p>
            </div>
            <div>
              <img src={SilverMedal} alt="" />
              <p>$1,500</p>
            </div>
            <div>
              <img src={BronzeMedal} alt="" />
              <p>$1,000</p>
            </div>
          </div>
          <p>
            At the end of the Challenge, all teams will be ranked based on both
            objective evaluation and subjective human evaluation. The top three
            performing teams will receive award certificates and cash prizes. At
            the same time, all accepted submissions will qualify for the
            conference’s grand challenge award competition. Each winning team
            for the cash prizes will be required to open source their proposed
            methods and submit a paper to the conference to explain the details
            of the methods.
          </p>
          {/* duan */}

          <h2 id="Timeline">Timeline</h2>
          <ul>
            <li type="square">
              10 March, 2020: Web Site and Call for Participation Ready
            </li>
            <li type="square">6 April, 2020: Start registration</li>
            <li type="square">
              26 April, 2020: Train set available for download
            </li>
            <li type="square">
              23 June, 2020: Test set available for download
            </li>
            <li type="square">30 June, 2020: Results submission</li>
            <li type="square">3 July, 2020: Evaluation results announced</li>
            <li type="square">13 July, 2020: Paper submission deadline</li>
          </ul>
          {/* duan */}
          <h2>Dataset Description</h2>
          <p>
            General Description: CitySCENE dataset consists of videos which
            cover 12 real-world anomalies related to public safety and city
            management, including Accident, Carrying, Crowd, Explosion,
            Fighting, Graffiti, Robbery, Shooting, Smoking, Stealing, Sweeping,
            and WalkingDog. The training set is trimmed and the testing set is
            untrimmed. Some testing samples will be provided on 20 May.
          </p>
          <p>
            Training dataset:The training set consists of 758 normal and 1319
            anomalous videos. The videos in training set are trimmed manually
            and the labels are at video-level.
          </p>
          <table border="1" style={{ margin: "0 auto" }}>
            <tr>
              <td style={TDstyle}>Anomaly</td>
              <td style={TDstyle}># of videos</td>
            </tr>
            <tr>
              <td style={TDstyle}>Accident</td>
              <td style={TDstyle}>85</td>
            </tr>
            <tr>
              <td style={TDstyle}>Carrying</td>
              <td style={TDstyle}>68</td>
            </tr>
            <tr>
              <td style={TDstyle}>Explosion</td>
              <td style={TDstyle}>210</td>
            </tr>
            <tr>
              <td style={TDstyle}>Fighting</td>
              <td style={TDstyle}>264</td>
            </tr>
            <tr>
              <td style={TDstyle}>Graffiti</td>
              <td style={TDstyle}>103</td>
            </tr>
            <tr>
              <td style={TDstyle}>Robbery</td>
              <td style={TDstyle}>171</td>
            </tr>
            <tr>
              <td style={TDstyle}>Shooting</td>
              <td style={TDstyle}>75</td>
            </tr>
            <tr>
              <td style={TDstyle}>Smoking</td>
              <td style={TDstyle}>89</td>
            </tr>
            <tr>
              <td style={TDstyle}>Stealing</td>
              <td style={TDstyle}>30</td>
            </tr>
            <tr>
              <td style={TDstyle}>Sweeping</td>
              <td style={TDstyle}>98</td>
            </tr>
            <tr>
              <td style={TDstyle}>Walkingdog</td>
              <td style={TDstyle}>69</td>
            </tr>
            <tr>
              <td style={TDstyle}>Normal events</td>
              <td style={TDstyle}>758</td>
            </tr>
          </table>
          <p style={{ marginTop: "30px" }}>
            Testing dataset:The testing set includes a set of untrimmed videos,
            where anomaly mostly occurs for a short period of time.
          </p>

          {/* duan */}
          <h2>Submission Format </h2>
          <p>
            Each team is allowed to submit the results of at most five runs. One
            run must be selected as the primary run of the submission (we do not
            guarantee to evaluate the other runs). The performance of the
            primary run will be measured for performance comparison across
            teams. Please use the following JSON format when submitting your
            results for the challenge:
          </p>
          <pre className="json">
            {`
{
    "version": "VERSION 1.0",
    "result":[
        {
            "video_id": "video0001",
                "categories": []
        },
        ...
        {
            "video_id": "video0018",
            "categories": []
        }
    ],
    "external_data":{
        "used": "true", 
`}
            {`      `}
            <span style={{ color: "green" }}>
              {" "}
              # Boolean flag. True indicates used of external data.{" "}
            </span>
            <br />
            {`       "details": "..."`}
            <br />
            {`     `}
            <span style={{ color: "green" }}>
              {" "}
              # Detail descriptions of your external data.{" "}
            </span>
            {`
   }
}
`}
          </pre>
          <p>
            The example above is illustrative. Comments must be removed in your
            submission. The participants should send the results to
            jingyuan.cjy@alibaba-inc.com. After receiving the submission, we
            will evaluate the results and send the feedback to the participants
            by email.
          </p>
          <h2>Paper Submission </h2>
          <p>
            Please follow the guideline of ACM Multimedia 2020 Grand Challenge
            for the paper submission.
          </p>
        </div>
      </div>
    );
  }
}
